
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/providers/[...path]",
      function () {
        return require("private-next-pages/providers/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/providers/[...path]"])
      });
    }
  